import { exists } from '@/api'

export interface OrderListEditToken {
  value: string
}

export const defaultOrderListEditToken = (): OrderListEditToken => ({
  value: ''
})

export function OrderListEditTokenFromJSON(json: any): OrderListEditToken {
  return {
    value: exists(json, 'edit_token') ? json.edit_token : ''
  }
}
